export enum ImportFormat {
    NONE = 'NONE',
    SCENARIO = 'SCENARIO',
    STATS_PERFORM = 'STATS_PERFORM',
    TRACAB = 'TRACAB',
    SECOND_SPECTRUM = 'SECOND_SPECTRUM',
    DFL = 'DFL',
    SKILL_CORNER = 'SKILL_CORNER',
    BE_PRO = 'BE_PRO',
    SPORTS_CODE = 'SPORTS_CODE',
    LALIGA = 'LALIGA'
}